import React from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export function SearchBar(props) {
  const { variant, background, children, placeholder, borderRadius, sx, ...rest } = props;
  return (
    <Box sx={{ width: { xs: '100%', md: '200px' }, ...sx }} {...rest}>
      <TextField
        size='small'
        placeholder={placeholder || 'Search...'}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon fontSize='small' />
            </InputAdornment>
          ),
          sx: {
            bgcolor: background || 'action.hover',
            borderRadius: borderRadius || '30px',
            fontSize: '0.875rem',
            '& fieldset': { border: 'none' },
          },
        }}
      />
    </Box>
  );
}
